<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-if='!patch' class='mr-1' v-bind="attrs" v-on="on" :loading='loading' :disabled="loading" color="secondary" alt="Create a new patch"
        :to="`/movements/new?entity=${entity}&entity_id=${entity_id}&protocol_id=${protocol_id}`"><v-icon>mdi-bug</v-icon></v-btn>
      <v-btn v-else class='mr-1' v-bind="attrs" v-on="on" :to="`/patch/${patch.id}`" color="error"><v-icon>mdi-alert</v-icon></v-btn>
    </template>
    <span v-if="patch">{{ patch.note }}</span>
    <span v-else>Patch me</span>
  </v-tooltip>
</template>
<script>

const { getList } = require('@/api/base_entity')
// componente per creare e visualizzare patch di entita note

export default {
  name: 'Patch',
  props: {
    entity: String,
    entity_id: Number,
    protocol_id: Number
  },
  data () {
    return ({ patch: null, loading: true })
  },
  async created () {
    const { data } = await getList('patch', { entity: this.entity, entity_id: this.entity_id })
    if (data.length) {
      this.patch = data[0]
    }
    this.loading = false
  }
}
</script>
